import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import TableLayoutV2 from "components/TableLayoutV2";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import { useGetNotificationCategoriesQuery } from "store/services/notifications";

const categoryLabel = (category) => String(category || "").replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());

const ManageNotifications = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetNotificationCategoriesQuery();
  const rawCategories = Array.isArray(data) ? data : data?.categories || data?.records || [];
  const categories = rawCategories.map((item) => typeof item === "string" ? { id: item, category: item } : { ...item, id: item.id || item.category || item.key || item.value, category: item.category || item.key || item.value || item.name });
  const columns = [
    {
      head: "USER TYPE",
      accessor: "category",
      isComponent: true,
      component: (item) => <h6 className="m-0 fw-sbold text-capitalize">{item.label || item.name || categoryLabel(item.category)}</h6>
    },
    {
      head: "ACTIVE USERS",
      accessor: "activeUsers",
      isComponent: true, component: (item) => <h6 className="m-0 fw-sbold">{item.activeUsers || "--"}
      </h6>
    },
  ];

  return <section className="designations position-relative py-4">
    <Container fluid>
      <Row><Col lg="12" className="my-2">
        <div className="TableFilter">
          <h6 className="m-0 fw-bold main-head themeBlue">Manage Notifications</h6>
        </div>
      </Col>
        <Col lg="12" className="my-2">
          <div className="table-outer">{isLoading ? <div style={{ height: "200px" }}>
            <LoadingIndicator />
          </div> : isError ?
            <ErrorComponent /> :
            <TableLayoutV2
              data={categories}
              column={columns}
              handleRowClick={(item) => navigate(`/manage-notifications/${item.category}`)} />}
          </div>
        </Col>
      </Row>
    </Container>
  </section>;
};

export default ManageNotifications;
